import { pushToDataLayer } from '../../pushToDataLayer';
import {
  CovideoGTMVehicleItem,
  GTMEvent,
  GTMEventAttributes,
  GTMVehicleAttributes,
  GTMEventName,
} from '../../types';
import { mapToGtmVehicleAttributes } from '../../utils';

export function inventoryInteractionEvent({
  vehicleItem,
}: {
  vehicleItem: CovideoGTMVehicleItem;
}) {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.INVENTORY_INTERACTION,
  };

  const vehicleData: GTMVehicleAttributes =
    mapToGtmVehicleAttributes(vehicleItem);

  pushToDataLayer({
    ...eventAttributes,
    ...vehicleData,
  });
}
